module.exports = __webpack_public_path__ + "img/9788990878137.da3c0154.jpg";